<h1 mat-dialog-title>Nombre de souscripteur</h1>
<div mat-dialog-content>
  <mat-selection-list #list [multiple]="false">
    @for (option of owner$ | async; track option) {
      <mat-list-option [value]="option.ids">
        <mat-radio-button
          [checked]="option.ids === list.selectedOptions.selected[0]?.value"
          class="example-radio-button"
          [value]="option.ids"
        >
          {{ option.label }}
        </mat-radio-button>
      </mat-list-option>
    }
  </mat-selection-list>
</div>
<div mat-dialog-actions>
  <pr-button
    size="lg"
    type="button"
    display="neutral"
    label="Valid"
    (click)="onClick()"
  ></pr-button>
</div>
